export const ActionTypes = {
  FETCH_ALL: 'services/equipment/fetch_all',
  FETCH_ALL_PACKING_DEVICES: 'services/equipment/fetch_all_packing_devices',
  SET_ALL_PACKING_DEVICES: 'services/equipment/set_all_packing_devices',
  SET_ALL: 'services/equipment/set_all',
  SET_LOADER_STATUS: 'services/equipment/set_loader_status',
  FETCH_ALL_EQUIPMENTS: 'services/equipment/fetch_all_equipments',
  SET_ALL_EQUIPMENTS: 'services/equipment/set_all_equipments',
  SET_UNIQUE_DEVICE_ID_DATA: 'services/equipment/set_unique_device_id',
  FETCH_UNIQUE_DEVICE_ID: 'services/equipment/fetch_unique_device_id',
  ADD_OR_UPDATE_EQUIPMENT: 'services/equipment/add_or_update_equipment',
  DELETE_EQUIPMENT: 'services/equipment/delete_equipment',
  FETCH_ALL_EQUIPMENT_TYPES: 'services/equipment/fetch_all_equipment_types',
  FETCH_ENERGY_CONFIGS: 'services/equipment/fetch_energy_configs',
  SET_ALL_EQUIPMENT_TYPES: 'services/equipment/set_all_equipment_types',
  SET_ENERGY_CONFIGS: 'services/equipment/set_all_equipment_types',
  FETCH_EQUIPMENTS_BY_FACTORY_ID: 'services/equipment/fetch_equipments_by_factory_id',
  FETCH_STANDALONE_EQUIPMENTS_BY_FACTORY_ID: 'services/equipment/fetch_standalone_equipments_by_factory_id',
  SET_EQUIPMENTS_BY_FACTORY_ID: 'services/equipment/set_equipments_by_factory_id',
  IS_JOB_ASSIGNED: 'services/equipment/is_job_assigned',
  SET_IS_JOB_ASSIGNED: 'services/equipment/set_is_job_assigned',
  FETCH_IS_PLC_ID_CONNECTED: 'services/equipment/fetch_is_plc_id_connected',
  SET_IS_PLC_ID_CONNECTED: 'services/equipment/set_is_plc_id_connected',
  FETCH_ALL_VISION_EQUIPMENTS: 'services/equipment/fetch_all_vision_equipments',
  SET_ALL_VISION_EQUIPMENTS: 'services/equipment/set_all_vision_equipments',
  FETCH_EQUIPMENT_LINE_POSITION: 'services/equipment/fetch_equipment_line_position',
  SET_EQUIPMENT_LINE_POSITION: 'services/equipment/set_equipment_line_position',
};

const fetchAll = ({ equipmentParams }) => ({
  equipmentParams,
  type: ActionTypes.FETCH_ALL,
});

const fetchAllPackingDevices = ({ param }) => ({
  param,
  type: ActionTypes.FETCH_ALL_PACKING_DEVICES,
});

const setAllPackingDevices = ({ packingDeviceData }) => ({
  packingDeviceData,
  type: ActionTypes.SET_ALL_PACKING_DEVICES,
});
const setAll = ({ allEquipment }) => ({
  allEquipment,
  type: ActionTypes.SET_ALL,
});

const fetchAllEquipments = () => ({
  type: ActionTypes.FETCH_ALL_EQUIPMENTS,
});

const fetchAllVisionEquipments = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_ALL_VISION_EQUIPMENTS,
});

const setAllEquipments = ({ allEquipmentsData }) => ({
  allEquipmentsData,
  type: ActionTypes.SET_ALL_EQUIPMENTS,
});

const fetchUniqueDeviceId = deviceId => ({
  type: ActionTypes.FETCH_UNIQUE_DEVICE_ID,
  deviceId,
});

const setUniqueDeviceIdData = ({ uniqueDeviceIdData }) => ({
  uniqueDeviceIdData,
  type: ActionTypes.SET_UNIQUE_DEVICE_ID_DATA,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});
const addorUpdateEquipment = ({ equipmentData, actionName, equipmentParams, callback }) => ({
  equipmentData,
  actionName,
  equipmentParams,
  callback,
  type: ActionTypes.ADD_OR_UPDATE_EQUIPMENT,
});

const deleteEquipment = ({ id, equipmentParams }) => ({
  id,
  equipmentParams,
  type: ActionTypes.DELETE_EQUIPMENT,
});

const fetchAllEquipTypes = () => ({
  type: ActionTypes.FETCH_ALL_EQUIPMENT_TYPES,
});

const fetchEnergyConfigs = () => ({
  type: ActionTypes.FETCH_ENERGY_CONFIGS,
});

const setEnergyConfigs = ({ energyConfigs }) => ({
  energyConfigs,
  type: ActionTypes.SET_ENERGY_CONFIGS,
});

const setAllEquipTypes = ({ equipmentTypes }) => ({
  equipmentTypes,
  type: ActionTypes.SET_ALL_EQUIPMENT_TYPES,
});

const fetchEquipmentsByFactoryId = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_EQUIPMENTS_BY_FACTORY_ID,
});

const fetchStandaloneEquipmentsByFactoryId = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_STANDALONE_EQUIPMENTS_BY_FACTORY_ID,
});

const setEquipmentsByFactoryId = ({ factoryEquipments }) => ({
  factoryEquipments,
  type: ActionTypes.SET_EQUIPMENTS_BY_FACTORY_ID,
});

const isJobAssigned = ({ equipmentId }) => ({
  equipmentId,
  type: ActionTypes.IS_JOB_ASSIGNED,
});

const setIsJobAssigned = ({ isJobAssigned }) => ({
  isJobAssigned,
  type: ActionTypes.SET_IS_JOB_ASSIGNED,
});
const fetchIsPlcIdConnected = ({ equipmentId, plcId, callback }) => ({
  equipmentId,
  plcId,
  callback,
  type: ActionTypes.FETCH_IS_PLC_ID_CONNECTED,
});
const setIsPlcIdConnected = ({ isPlcIdConnected }) => ({
  isPlcIdConnected,
  type: ActionTypes.SET_IS_PLC_ID_CONNECTED,
});

const setAllVisionEquipments = ({ allVisionEquipments }) => ({
  allVisionEquipments,
  type: ActionTypes.SET_ALL_VISION_EQUIPMENTS,
});

const fetchEquipmentLinePosition = ({ equipmentId }) => ({
  equipmentId,
  type: ActionTypes.FETCH_EQUIPMENT_LINE_POSITION,
});

const setEquipmentLinePosition = ({ equipmentLinePosition }) => ({
  equipmentLinePosition,
  type: ActionTypes.SET_EQUIPMENT_LINE_POSITION,
});

export default {
  fetchAll,
  fetchUniqueDeviceId,
  setUniqueDeviceIdData,
  fetchAllPackingDevices,
  setAllPackingDevices,
  setAll,
  setLoader,
  fetchAllEquipments,
  setAllEquipments,
  addorUpdateEquipment,
  deleteEquipment,
  fetchAllEquipTypes,
  setAllEquipTypes,
  setEnergyConfigs,
  fetchEnergyConfigs,
  fetchEquipmentsByFactoryId,
  fetchStandaloneEquipmentsByFactoryId,
  setEquipmentsByFactoryId,
  isJobAssigned,
  setIsJobAssigned,
  fetchIsPlcIdConnected,
  setIsPlcIdConnected,
  fetchAllVisionEquipments,
  setAllVisionEquipments,
  fetchEquipmentLinePosition,
  setEquipmentLinePosition,
};
